module.exports = __webpack_public_path__ + "static/media/hugo.17b7bf26.jpg";